/*
 * Klassy Difference — tab switcher.
 * Click on .klassy-difference__tab-button → toggle --active class + aria-selected
 * + show/hide tab-panel by matching data-tab → data-tab-content.
 */
(function () {
  if (window.__klassyDifferenceInit) return;
  window.__klassyDifferenceInit = true;

  function initTabs(section) {
    var buttons = [].slice.call(section.querySelectorAll('.klassy-difference__tab-button'));
    var panels = [].slice.call(section.querySelectorAll('.klassy-difference__tab-panel'));

    function activate(tabId) {
      buttons.forEach(function (b) {
        var isActive = b.getAttribute('data-tab') === tabId;
        b.classList.toggle('klassy-difference__tab-button--active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        b.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      panels.forEach(function (p) {
        var isActive = p.getAttribute('data-tab-content') === tabId;
        p.classList.toggle('klassy-difference__tab-panel--active', isActive);
        if (isActive) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        activate(b.getAttribute('data-tab'));
      });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var idx = buttons.indexOf(b);
        if (idx === -1) return;
        var nextIdx = e.key === 'ArrowRight' ? (idx + 1) % buttons.length : (idx - 1 + buttons.length) % buttons.length;
        buttons[nextIdx].focus();
        activate(buttons[nextIdx].getAttribute('data-tab'));
      });
    });
  }

  function initSwatches(section) {
    section.querySelectorAll('[data-kld-card]').forEach(function (card) {
      var img = card.querySelector('[data-kld-img]');
      var swatches = [].slice.call(card.querySelectorAll('[data-kld-swatch]'));
      var links = [].slice.call(card.querySelectorAll('[data-kld-link]'));
      if (!img || !swatches.length) return;
      var defaultSrc = img.getAttribute('data-default-src') || img.src;
      var defaultAlt = img.alt;

      swatches.forEach(function (sw) {
        var newImg = sw.getAttribute('data-variant-image');
        var newUrl = sw.getAttribute('data-variant-url');
        var newAlt = sw.getAttribute('data-variant-alt');

        function activate() {
          if (newImg && img.src !== newImg) img.src = newImg;
          if (newAlt) img.alt = newAlt;
          if (newUrl) links.forEach(function (a) { a.href = newUrl; });
          swatches.forEach(function (s) {
            s.classList.remove('is-active');
            s.removeAttribute('aria-current');
          });
          sw.classList.add('is-active');
          sw.setAttribute('aria-current', 'true');
        }
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          activate();
        });
        sw.addEventListener('mouseenter', activate);
      });
    });
  }

  function init() {
    document.querySelectorAll('.klassy-difference').forEach(function (section) {
      initTabs(section);
      initSwatches(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
